import { createSlice } from '@reduxjs/toolkit';
import { IUsersState } from './types';
import {
    asyncFetchSessionUser,
    asyncFetchUsers,
    asyncFetchSessionUserScores,
    asyncFetchUserScores,
    asyncFetchScoreTypes,
} from './thunks';
import {
    setScoreTypes,
    setSessionUserScores,
    setUser,
    setUsers,
    setUserScores,
} from './reducer';

const initialState: IUsersState = {
    user: undefined,
    userScores: [],
    sessionUserScores: [],
    users: [],
    scoreTypes: [],
};
export const reducers = {};

const slice = createSlice({
    name: 'settings',
    initialState,
    reducers,
    extraReducers: builder => {
        builder.addCase(asyncFetchSessionUser.fulfilled, setUser);
        builder.addCase(
            asyncFetchSessionUserScores.fulfilled,
            setSessionUserScores
        );
        builder.addCase(asyncFetchUsers.fulfilled, setUsers);
        builder.addCase(asyncFetchUserScores.fulfilled, setUserScores);
        builder.addCase(asyncFetchScoreTypes.fulfilled, setScoreTypes);
    },
});

export default slice.reducer;
